import {
    Location,
    ServiceOrder,
    ServiceOrderPage,
    ServiceOrderStatus,
    ServiceOrderVehicle,
} from '../../../serviceOrders/serviceOrders/serviceOrder.types';
import { parseOptionalStringDate, parseStringDate } from '../../../sharedComponents/dateHelper';
import { ApiAccessoryType } from '../../types/serviceOrder/accessoriesApi.types';
import {
    ApiLocation,
    ApiServiceOrder,
    ApiServiceOrderBulkSelection,
    ApiServiceOrderPage,
    ApiServiceOrderStatus,
    ApiServiceOrderVehicle,
} from '../../types/serviceOrder/serviceOrdersApi.types';
import { mapToPartialAddress } from '../addressMappers';
import { mapToTimeZone } from '../timeZoneMappers';
import { mapToVehicleId } from '../sharedVehicleMappers';
import { mapToAccessoryType, mapToCollectedAccessories } from './accessoriesMapper';
import { mapToServiceType } from './serviceTypeMapper';
import { mapToServiceVehicleModel } from './serviceVehicleMapper';

export const mapToServiceOrderStatus = (apiServiceOrderStatus: ApiServiceOrderStatus): ServiceOrderStatus => {
    switch (apiServiceOrderStatus) {
        case ApiServiceOrderStatus.OPEN:
            return ServiceOrderStatus.OPEN;
        case ApiServiceOrderStatus.COMPLETED:
            return ServiceOrderStatus.COMPLETED;
        case ApiServiceOrderStatus.CANCELLED:
            return ServiceOrderStatus.CANCELLED;
    }
};

export const mapToServiceOrderVehicle = (apiServiceOrderVehicle: ApiServiceOrderVehicle): ServiceOrderVehicle => ({
    id: mapToVehicleId(apiServiceOrderVehicle.id),
    requestedAccessories: apiServiceOrderVehicle.requested_accessories.map((accessory: ApiAccessoryType) =>
        mapToAccessoryType(accessory),
    ),
    model: apiServiceOrderVehicle.model && mapToServiceVehicleModel(apiServiceOrderVehicle.model),
    collectedAccessories:
        apiServiceOrderVehicle.collected_accessories &&
        mapToCollectedAccessories(apiServiceOrderVehicle.collected_accessories),
});

export const mapToLocation = (apiLocation: ApiLocation): Location => ({
    timeZone: mapToTimeZone(apiLocation.time_zone),
    identifier: apiLocation.identifier,
    address: apiLocation.address ? mapToPartialAddress(apiLocation.address) : undefined,
});

export const mapToServiceOrderIds = (apiBulkSelection: ApiServiceOrderBulkSelection): string[] =>
    apiBulkSelection.order_ids;

export const mapToServiceOrder = (apiServiceOrder: ApiServiceOrder): ServiceOrder => ({
    id: apiServiceOrder.id,
    externalOrderId: apiServiceOrder.external_order_id,
    serviceLocation: mapToLocation(apiServiceOrder.service_location),
    generalInformation: apiServiceOrder.general_information,
    startedAt: parseOptionalStringDate(apiServiceOrder.started_at),
    completedAt: parseOptionalStringDate(apiServiceOrder.completed_at),
    orderIssuedAt: parseStringDate(apiServiceOrder.order_issued_at),
    vehicle: mapToServiceOrderVehicle(apiServiceOrder.vehicle),
    status: mapToServiceOrderStatus(apiServiceOrder.status),
    type: mapToServiceType(apiServiceOrder.type),
    description: apiServiceOrder.description,
    hasUnacknowledgedExternalChanges: apiServiceOrder.has_unacknowledged_external_changes,
    isFinalized: apiServiceOrder.is_finalized,
    isArchived: apiServiceOrder.is_archived,
    externalOptionId: apiServiceOrder.external_option_id,
});

export const mapToServiceOrders = (apiServiceOrderPage: ApiServiceOrderPage): ServiceOrderPage => ({
    items: apiServiceOrderPage.items.map((apiServiceOrder: ApiServiceOrder): ServiceOrder =>
        mapToServiceOrder(apiServiceOrder),
    ),
    hasMore: apiServiceOrderPage.has_more,
});
